export const abbreviateNumber = n => {
  if (n < 1e3) return "500+";
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
}

export const getFormattedPrice = (price, currencyCode) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(price).replace(/\.00/g, '')
}


export const getFullName = (firstName, lastName) => {
  const fullNameArray = [firstName, lastName].filter(Boolean);
  return fullNameArray.length > 0 ? fullNameArray.join(' ') : '';
}

export const splitFullName = (value) => {
  if (value) {
    const names = value.trim().split(' ');
    let lastName = names.pop();
    let firstName = names.join(' ');
    if (!firstName) {
      firstName = lastName;
      lastName = '';
    }
    return { firstName, lastName };
  }
  return { firstName: '', lastName: '' }
}

export const capitalizeFirst = (stringText) => {
  if (stringText && (typeof stringText === 'string' || stringText instanceof String)) {
    const loweredString = stringText.toLowerCase();
    return loweredString.charAt(0).toUpperCase() + loweredString.slice(1);
  }
  return '';
}

export const decodeHtml = (html) => {
  let decoded = html;
  if (!html) {
    return '';
  }
  let before = '';
  while (decoded !== before) {
    before = decoded;
    const txt = document.createElement('textarea');
    txt.innerHTML = before;
    decoded = txt.value;
  }
  return decoded;
}

export const appendParamToUrl = (url, paramName, paramValue) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`;
}